const PWA_API_URL = "https://betika-pwa-api.now.sh/api/";

const VAPID_PUBLIC_KEY =
	"BJ8xTGECk_uDBloseJrDfQvJ_OobMLlD0ip-lp_PaVSMn5Zi5ZszGIuhDHcvh0Q-DSKDYqX9v96zHPHwxV1z15Y";
/**
 * Ask the user for permissions to send notifications
 */
export function askForNotificationPermission() {
	return new Promise((resolve, reject) => {
		// Check whether the user's browser supports notifications
		if ("Notification" in window) {
			// Request permissions
			Notification.requestPermission((status) => {
				console.log("Notification permission status:", status);
				if (Notification.permission === "denied") {
					reject("You have blocked notifications");
				} else {
					resolve(status);
				}
			});
		} else {
			console.log("This browser does not support notifications");
			reject("This browser does not support notifications");
		}
	});
}

/**
 * Returns true/false based on whether the user has blocked
 */
export function getNotificationStatus() {
	if (!("Notification" in window))
		return {
			status: false,
			reason: "Your browser does not support notifications",
		};
	if (Notification.permission === "denied")
		return {
			status: false,
			reason:
				"Your have blocked notifications. To enable Go to Settings > Site Settings > Notifications > Allow",
		};
	if (Notification.permission === "default")
		return { status: false, reason: "Notifications set to ask" };
	if (Notification.permission === "granted")
		return { status: true, reason: "Thank you for granting notifications" };
	return { status: false, reason: "Notifications not set" };
}
/**
 * Sets up hooks for for add to homescreen
 */
export function initAddToHomeScreen(
	beforeInstallCallback,
	dismissedCallback,
	addedCallback
) {
	// Before install to homescreen
	window.addEventListener("beforeinstallprompt", function(event) {
		var isChrome = navigator.userAgent.indexOf("Chrome") > -1;
		// If the user is on Chrome, pop banner to motivate add to homescreen
		if (isChrome) {
			// beforeInstallCallback(true);
		}
		event.userChoice.then(function(choiceResult) {
			// Once the user makes the choice remove the banner
			if (choiceResult.outcome == "dismissed") {
				console.log("User cancelled home screen install");
				dismissedCallback(false);
			} else {
				console.log("User added to home screen");
				addedCallback(false, true);
			}
		});
	});
}

/**
 * Register service worker
 */
export function registerServiceWorker() {
	return new Promise((resolve, reject) => {
		// Check whether the user's browser supports service worker and registers it
		if ("serviceWorker" in navigator) {
			navigator.serviceWorker
				.register("service-worker.js")
				.then(function(registration) {
					console.log("Service Worker is registered", registration);
					resolve(registration);
				})
				.catch(function(error) {
					console.error("Service Worker Error", error);
					reject("Service Worker Error", error);
				});
		} else {
			console.warn("Service worker is not supported");
			reject("Service worker is not supported");
		}
	});
}

/**
 * Check push notification status
 */
export function checkPushStatus() {
	return new Promise((resolve, reject) => {
		//To check `push notification` permission is denied by user
		if (Notification.permission === "denied") {
			reject("You have blocked push notifications.");
		}

		//Check `push notification` is supported or not
		if (!("PushManager" in window)) {
			reject("Sorry, Push notification isn't supported in your browser.");
		}

		navigator.serviceWorker.ready
			.then(function(registration) {
				registration.pushManager
					.getSubscription()
					.then(function(subscription) {
						//If already access granted, enable push button status
						if (subscription) {
							saveSubscriptionID(subscription)
								.catch((response) => resolve(response))
								.then((error) => resolve("Probably already subscribed"));
						} else {
							reject("Access not granted");
						}
					})
					.catch(function(error) {
						reject("Error occurred while enabling push " + error);
					});
			})
			.catch((error) => reject(error));
	});
}

/**
 * Subscribe to push notifications
 */
export function subscribePush(swRegistration) {
	return new Promise((resolve, reject) => {
		//Check `push notification` is supported or not
		if (!("PushManager" in window)) {
			reject({
				status: false,
				reason: "Sorry, Push notification isn't supported in your browser.",
			});
		}

		if (!swRegistration.pushManager) {
			reject({
				status: false,
				reason: "Sorry, Push notification isn't supported in your browser.",
			});
		}
		//To subscribe `push notification` from push manager
		swRegistration.pushManager
			.subscribe({
				userVisibleOnly: true, //Always show notification when received
				applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
			})
			.then(function(subscription) {
				console.log(subscription);
				// Save to DB
				saveSubscriptionID(subscription)
					.then((response) => resolve(response))
					.catch((error) => reject(error));
			})
			.catch((error) => reject(error));
	});
}

/**
 * Unsubscribe to push notifications
 */
export function unsubscribePush() {
	return new Promise((resolve, reject) => {
		navigator.serviceWorker.ready.then(function(registration) {
			//Get `push subscription`
			registration.pushManager
				.getSubscription()
				.then(function(subscription) {
					//If no `push subscription`, then return
					if (!subscription) {
						reject("Unable to unregister push notification.");
					}

					//Unsubscribe `push notification`
					subscription
						.unsubscribe()
						.then(function() {
							deleteSubscriptionID(subscription)
								.then((response) => resolve(response))
								.catch((error) => reject(error));
						})
						.catch((error) => reject(error));
				})
				.catch((error) => reject(error));
		});
	});
}

/**
 * Protected function
 * Save subscription ID to DB so that user can be notified from server
 */
function saveSubscriptionID(subscription) {
	var user = localStorage.user ? JSON.parse(localStorage.user) : null;
	var subscription_id = subscription.endpoint.split("fcm/send/")[1];
	console.log("Subscription ID", subscription_id);
	console.log("Subscription", subscription);
	var req = {
		user_id: subscription_id,
		subscription: subscription,
	};
	if (user) {
		req.profile_id = user.id;
		req.mobile = user.mobile;
	}
	return new Promise((resolve, reject) => {
		fetch(PWA_API_URL + "users", {
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(req),
		})
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

/**
 * Protected function
 * Delete subscription ID from DB to stop notifications from server
 */
function deleteSubscriptionID(subscription) {
	var subscription_id = subscription.endpoint.split("fcm/send/")[1];

	return new Promise((resolve, reject) => {
		fetch(PWA_API_URL + "user/" + subscription_id, {
			method: "delete",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

function urlBase64ToUint8Array(base64String) {
	const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding)
		.replace(/\-/g, "+")
		.replace(/_/g, "/");

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

// export default {askForNotificationPermission, initAddToHomeScreen, registerServiceWorker, checkPushStatus, subscribePush, unsubscribePush}
